/** The Communication lane — the full-width panel for what applies across the whole trip:
 *  My Trips display, the chat exclusions and the notification pauses, then the time axis
 *  of the booking's imports, changes, deliveries and planned notifications (`TimeAxis`). */
import type { BookingRecordStage } from '@/api/bookingRecord';
import type { ViewSection } from '@/features/records/views/types';

import type { BookingDisplayContext } from './displays';
import { PanelMeta } from './PanelMeta';
import { StagePanel } from './StagePanel';
import { TimeAxis } from './TimeAxis';

export function CommunicationLane({
  section,
  display,
}: {
  section: ViewSection<BookingRecordStage>;
  display: BookingDisplayContext;
}) {
  return (
    <StagePanel
      section={section}
      display={display}
      meta={<PanelMeta>Across the whole trip</PanelMeta>}
      afterEditable={<TimeAxis bookingId={display.editContext.booking_id} timezone={display.tz} />}
    />
  );
}
